module.exports = __webpack_public_path__ + "img/dashboard_en.738e33b.png";